import dayjs from "dayjs";
import { detectExportIntent } from "./detectExportIntent";

export const detectDashboardIntent = (query: string) => {
    if (!query) return null;
    const q = query.toLowerCase();

    let status: "active" | "inactive" | null = null;

    // Month map
    const monthMap: any = {
        jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
        jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12"
    };

    // NATURAL DATE matcher
    const naturalDatePattern = /(\d{1,2})\s*(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\s*(\d{2,4})?/;

    // Extract from/to natural dates
    const naturalFromMatch = q.match(/from\s+(\d{1,2}\s*[a-zA-Z]+\s*\d{0,4})/);
    const naturalToMatch = q.match(/to\s+(\d{1,2}\s*[a-zA-Z]+\s*\d{0,4})/);

    const parseNaturalDate = (text: string | undefined) => {
        if (!text) return null;

        const parts = text.match(naturalDatePattern);
        if (!parts) return null;

        const day = parts[1];
        const monthText = parts[2].slice(0, 3).toLowerCase();
        const year = parts[3] || dayjs().year().toString(); // default current year

        const monthNum = monthMap[monthText];

        return dayjs(`${year}-${monthNum}-${day}`).format("YYYY-MM-DD");
    };

    const parsedFromDate = naturalFromMatch ? parseNaturalDate(naturalFromMatch[1]) : null;
    const parsedToDate = naturalToMatch ? parseNaturalDate(naturalToMatch[1]) : null;

    // Employee detection
    // -----------------------------------------
    // IMPROVED EMPLOYEE NAME DETECTION
    // -----------------------------------------

    let employeeName: string | null = null;

    // Pattern 1: "employee rahul"
    const empPattern1 = /(employee|emp|staff)\s+([a-zA-Z ]+)/;
    const match1 = q.match(empPattern1);

    // Pattern 2: "summary of rahul"
    const empPattern2 = /summary of\s+([a-zA-Z ]+)/;
    const match2 = q.match(empPattern2);

    // Pattern 3: "for rahul"
    const empPattern3 = /for\s+([a-zA-Z ]+)/;
    const match3 = q.match(empPattern3);

    // Pattern 4: "rahul's attendance"
    const empPattern4 = /([a-zA-Z]+)'s\s+(attendance|summary|report)/;
    const match4 = q.match(empPattern4);

    // Assign match
    if (match1) employeeName = match1[2].trim();
    else if (match2) employeeName = match2[1].trim();
    else if (match3) employeeName = match3[1].trim();
    else if (match4) employeeName = match4[1].trim();

    if (employeeName) {
        employeeName = employeeName
            .replace(/\b(from|to|of|the|report|summary|attendance)\b/g, "")
            .trim();
    }

    // Month/year extraction
    const monthPattern = /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\b/;
    const yearPattern = /\b(20\d{2})\b/;

    const monthMatch = q.match(monthPattern);
    const yearMatch = q.match(yearPattern);

    const currentMonth = (dayjs().month() + 1).toString().padStart(2, "0");
    const currentYear = dayjs().year().toString();

    const parsedMonth = monthMatch ? monthMap[monthMatch[0].slice(0, 3)] : currentMonth;
    const parsedYear = yearMatch ? yearMatch[0] : currentYear;


    const exportIntent = detectExportIntent(query);
    if (exportIntent) return exportIntent;


    // STATUS
    if (q.includes("active employee") || q.includes("working employees") || q.includes("active"))
        status = "active";
    if (q.includes("inactive employee") || q.includes("resigned") || q.includes("terminated") || q.includes("inactive"))
        status = "inactive";

    // ATTENDANCE SUMMARY
    if (
        q.includes("attendance summary") ||
        q.includes("summary report") ||
        q.includes("attendance overview")
    ) {
        return {
            intent: "show_attendance_summary",
            fromDate: parsedFromDate,
            toDate: parsedToDate,
            month: parsedMonth,
            year: parsedYear,
            employee: employeeName
        };
    }

    // OTHER INTENTS
    if (q.includes("attendance"))
        return { intent: "show_attendance", month: parsedMonth, year: parsedYear };

    if (q.includes("team attendance"))
        return { intent: "show_team_attendance" };

    // -----------------------------------------
    // EXPORT REPORT DETECTION
    // -----------------------------------------

    if (q.includes("employee") || q.includes("emp"))
        return { intent: "show_employee_count", status };

    if (q.includes("leave balance"))
        return { intent: "show_leave_balance" };

    if (q.includes("holiday"))
        return { intent: "show_holidays" };

    if (q.includes("salary") || q.includes("slry"))
        return { intent: "show_salary", month: parsedMonth, year: parsedYear };

    if (monthMatch)
        return { intent: "show_salary_by_month", month: parsedMonth, year: parsedYear };
     
    if (q.includes("onboarding"))
        return { intent: "show_onboarding_report", status };

    if (q.includes("offboarding"))
        return { intent: "show_offboarding_report",};

    if (q.includes("training"))
        return { intent: "show_training_report", status};
    
    if (q.includes("organisation skill"))
        return { intent: "show_skill_matrix_report",};

    if (q.includes("overtime"))
        return { intent: "show_over_time_report"};
    
     if (q.includes("timesheet"))
        return { intent: "show_timesheet_report"};
    
    if (q.includes("timesheetlog"))
        return { intent: "show_timesheetlog_report"};

    if (q.includes("shift"))
        return { intent: "show_shift_report"};

     if (q.includes("project"))
        return { intent: "show_project_report"};

     if (q.includes("task"))
        return { intent: "show_task_report"};

       if (q.includes("user"))
        return { intent: "show_user_report"};
      
       if (q.includes("payslip"))
        return { intent: "show_payslip_report"};

       if (q.includes("budget"))
        return { intent: "show_budget_report"};
    
       if (q.includes("reimbursement"))
        return { intent: "show_expenses_report"};
      
       if (q.includes("esi"))
        return { intent: "show_esi_report"};

          if (q.includes("tds"))
        return { intent: "show_tds_report"};

    if (q.includes("pf"))
        return { intent: "show_pf_report"};

      if (q.includes("assetsallocation"))
        return { intent: "show_assetsallocation_report"};

     if (q.includes("maintenance"))
        return { intent: "show_assetmaintaince_report"};
     
     if (q.includes("daily"))
        return { intent: "show_daily_report"};
    
     if (q.includes("invoice"))
        return { intent: "show_invoice_report"};
    // -----------------------------------------
    // LEAVE REPORT DETECTION
    // -----------------------------------------

    if (
        q.includes("leave report") ||
        q.includes("leave summary") ||
        q.includes("leave data") ||
        q.includes("leaves")
    ) {
        // Detect Status
        let leaveStatus: "Approved" | "Pending" | "Rejected" | null = null;

        if (q.includes("approved")) leaveStatus = "Approved";
        if (q.includes("pending")) leaveStatus = "Pending";
        if (q.includes("rejected") || q.includes("declined")) leaveStatus = "Rejected";

        return {
            intent: "show_leave_report",
            month: parsedMonth,
            year: parsedYear,
            status: leaveStatus
        };
    }

    // -----------------------------------------
    // LEAVE LEDGER REPORT (AI-driven filter support)
    // -----------------------------------------

    if (
        q.includes("leave ledger") ||
        q.includes("ledger report") ||
        q.includes("leave balance details") ||
        q.includes("ledger")
    ) {
        let employeeKeyword = null;
        let departmentKeyword = null;
        let designationKeyword = null;

        // Extract employee name e.g. "for rahul", "employee raj", "rahul ledger"
        const empMatch = q.match(/(employee|emp|staff)\s+([a-zA-Z ]+)/);
        if (empMatch) employeeKeyword = empMatch[2].trim();

        const empMatch2 = q.match(/for\s+([a-zA-Z ]+)/);
        if (empMatch2) employeeKeyword = empMatch2[1].trim();

        // Department detection
        const deptMatch = q.match(/department\s+([a-zA-Z ]+)/);
        if (deptMatch) departmentKeyword = deptMatch[1].trim();

        // Designation detection
        const desigMatch = q.match(/designation\s+([a-zA-Z ]+)/);
        if (desigMatch) designationKeyword = desigMatch[1].trim();

        return {
            intent: "show_leave_ledger",
            employee: employeeKeyword,
            department: departmentKeyword,
            designation: designationKeyword,
            month: parsedMonth,
            year: parsedYear
        };
    }


    if (q.includes("report"))
        return { intent: "generic_report" };

    return null;
};
